import { useState, useEffect, Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Wallet, Euro, TrendingUp, Loader2, Lock, Scale } from "lucide-react";

const BudgetPage = lazy(() => import("./finanzas/BudgetPage"));
const PresupuestoPage = lazy(() => import("./finanzas/PresupuestoPage"));
const FinancePage = lazy(() => import("./finanzas/FinancePage"));
const CostByBusinessLine = lazy(() => import("./finanzas/CostByBusinessLine"));

export default function FinanzasPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "plan";
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    if (tab !== params.get("tab")) {
      setParams({ tab }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div className="p-6 space-y-4" data-testid="finanzas-page">
      <div className="border-b pb-4">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">Innovation OS · Finanzas</div>
        <h1 className="text-2xl font-bold tracking-tight">Control Financiero</h1>
        <p className="text-sm text-muted-foreground mt-1">Plan presupuestario · Ejecución real · Análisis y proyectos I+D.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="plan" data-testid="finanzas-tab-plan"><Wallet className="w-4 h-4 mr-2" />Plan</TabsTrigger>
          <TabsTrigger value="real" data-testid="finanzas-tab-real">
            <Euro className="w-4 h-4 mr-2" /> Real
          </TabsTrigger>
          <TabsTrigger value="analisis" data-testid="finanzas-tab-analisis"><TrendingUp className="w-4 h-4 mr-2" />Análisis I+D</TabsTrigger>
          <TabsTrigger value="comparativa" data-testid="finanzas-tab-comparativa"><Scale className="w-4 h-4 mr-2" />Comparativa por Línea</TabsTrigger>
        </TabsList>

        <div className="-mx-6 -mt-2">
          <Suspense fallback={<div className="p-12 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>}>
            <TabsContent value="plan" className="mt-0"><BudgetPage /></TabsContent>
            <TabsContent value="real" className="mt-0">
              <PresupuestoPage />
            </TabsContent>
            <TabsContent value="analisis" className="mt-0"><FinancePage /></TabsContent>
            <TabsContent value="comparativa" className="mt-0 px-6"><CostByBusinessLine /></TabsContent>
          </Suspense>
        </div>
      </Tabs>
    </div>
  );
}
